import { AutocompleteFieldItem } from '@domains/documents-review/interfaces/interfaces';

export type FeedbackType =
  | 'accept_suggestion'
  | 'change_suggestion'
  | 'manual_edit';

export const mapFeedbackType = (item: AutocompleteFieldItem): FeedbackType => {
  const hasManual =
    !item.selectedModel && !!item.finalValue && item.finalValue !== '';
  if (hasManual) return 'manual_edit';
  const isDefault =
    !!item.defaultSuggestionId &&
    item.selectedSuggestionId === item.defaultSuggestionId;
  return isDefault ? 'accept_suggestion' : 'change_suggestion';
};
